import { Stack } from '@cp/ds/src/components/stack';
import { SxProps } from '@cp/ds/src/theme';
import { ClientProfileViewModel } from '@common/model/client';
import { ModerationToggleVariant } from 'src/features/moderation/moderationToggle';
import { ToggleClientDocumentsCheck } from 'src/features/moderation/toggleClientDocumentsCheck';
import { ToggleClientWorking } from 'src/features/moderation/toggleClientWorking';

export const ProfileModerationToggles = ({
  clientProfile,
  variant = 'default',
  sx,
}: {
  clientProfile?: ClientProfileViewModel;
  variant?: ModerationToggleVariant;
  sx?: SxProps;
}) => {
  if (variant === 'compact') {
    return (
      <Stack gap={1} sx={sx}>
        <ToggleClientDocumentsCheck clientProfile={clientProfile} variant="compact" />
        <ToggleClientWorking clientProfile={clientProfile} variant="compact" />
      </Stack>
    );
  }

  return (
    <Stack gap={2.5} sx={sx}>
      <ToggleClientDocumentsCheck clientProfile={clientProfile} />
      <ToggleClientWorking clientProfile={clientProfile} />
    </Stack>
  );
};
